import React, { useState } from 'react';
import Slider from 'react-rangeslider';
import { DraggableProvided } from 'react-beautiful-dnd';
import WidgetModel from '@mm/state/model/WidgetModel';
import { round } from 'lodash';
import { useTypingWidgetHandlers } from '../../helpers/widget-helpers/use-typing-widget-handlers';
import './TypingWidget.scss';
import { WidgetControls } from '../common/WidetControls/WidgetControls';
import { FacebookPageIcon } from '../common/FacebookPageIcon/FacebookPageIcon';
import {
  ErrorPortal,
  WidgetContainerRefProp,
} from '../../../editor/features/startBotPromoters/common/StartBotsDialogueEditor/WidgetByType/WidgetByType';
import { WidgetUnsupportedError } from '../errors/WidgetUnsupportedError/WidgetUnsupportedError';
import { PlatformType } from '@mm/state/model/CampaignsModel';

type Props = {
  widget: WidgetModel;
  draggableProvided?: DraggableProvided;
  isSmsRelated?: boolean;
  smsOnly?: boolean;
  platforms?: PlatformType[];
} & WidgetContainerRefProp;

const TypingConstants = {
  MIN_VALUE: 1,
  MAX_VALUE: 20,
  STEP: 1,
  LABELS: {
    1: '1s',
    20: '20s',
  },
  CUSTOM_HEADER: 'Show typing for ',
};

export const TypingWidget = (props: Props) => {
  const { widget, draggableProvided, isSmsRelated, smsOnly, platforms } = props;
  const [delayValue, setDelayValue] = useState(widget.config.seconds);
  const { MIN_VALUE, MAX_VALUE, STEP, LABELS, CUSTOM_HEADER } = TypingConstants;
  const typingWidgetHandlers = useTypingWidgetHandlers();

  const handleChange = (value: number) => {
    if (value) {
      const roundValue = round(value, 1);
      setDelayValue(roundValue);
    }
  };

  const onValueChange = () =>
    typingWidgetHandlers.updateDelay(widget, delayValue);

  return (
    <div className="typing-widget">
      <FacebookPageIcon />

      <div className="typing-widget__wrapper">
        <div className="typing-widget__custom-header">
          {`${CUSTOM_HEADER} ${delayValue}sec`}
        </div>

        <Slider
          className="typing-widget__range-slider"
          min={MIN_VALUE}
          max={MAX_VALUE}
          step={STEP}
          value={delayValue}
          labels={LABELS}
          onChange={handleChange}
          onChangeComplete={onValueChange}
        />
      </div>

      <WidgetControls
        widget={widget}
        draggableProvided={draggableProvided}
        platforms={platforms}
      />

      {isSmsRelated && !widget.supportedByPlatforms.sms && (
        <ErrorPortal widget={widget}>
          <WidgetUnsupportedError isError={smsOnly} type="sms" />
        </ErrorPortal>
      )}
    </div>
  );
};
